import { Box } from '@/primitives';
import { SaleType } from '../constants';

// Report codes mark published results. A past date alone does not: listings
// can remain available after the sale without the society supplying results.
const REPORT_TYPES: readonly string[] = [
  SaleType.CompletedSaleListing,
  SaleType.CompletedPrivateTreatySaleListing,
];

export function SaleResultsLabel({
  saleType,
  saleName,
}: {
  saleType: string;
  saleName: string;
}) {
  if (
    !REPORT_TYPES.includes(saleType.trim().toUpperCase()) ||
    saleName.toLowerCase().includes('results')
  ) {
    return null;
  }

  return (
    <Box
      component="span"
      sx={{
        color: 'text.secondary',
        fontSize: '12px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        ml: 0.75,
      }}
    >
      (Results)
    </Box>
  );
}
